<template>
    <main id="modal" class="abs">
        <div class="ticket-select rel">
            <div class="rel"><i class="close-dialog" @click="closeDialog();"></i></div>
            <h1 class="title">{{ $t("configurator.ticket") }}</h1>
            <div v-if="ticket !== null" v-for="ticket in tickets" class="content-ticket">
                <input
                    :id="'ticket_' + ticket.id"
                    @click="addTicket(ticket, $event.target.checked);"
                    type="checkbox"
                    v-checked="checkedTicketStrip(ticket)"
                /><label :for="'ticket_' + ticket.id">{{ getTranslate(ticket.terms.name) }}</label>
            </div>
            <div class="buttonbar">
                <button class="btn" @click="valid">OK</button>
                <!-- <button class="btn" @click="cancel">cancel</button> -->
            </div>
        </div>
    </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    props: {
        ticketStrips: { type: Array, default: [] }
    },
    data() {
        return {
            tickets: null,
            ticketsSelected: []
        };
    },
    computed: {
        ...mapGetters("items", {
            getRelatedTicketsStrip: "getRelatedTicketsStrip"
        })
    },
    created() {
        this.findRelatedTicketsStrip({ id: this.$route.params.id }).then(() => {
            this.tickets = this.getRelatedTicketsStrip;
            this.tickets.forEach(ticket => {
                if (this.checkedTicketStrip(ticket)) {
                    this.ticketsSelected.push(ticket);
                }
            });
        });
    },
    mounted() {},
    methods: {
        ...mapActions("items", {
            findRelatedTicketsStrip: "findRelatedTicketsStrip"
        }),
        checkedTicketStrip(ticket) {
            let result = this.ticketStrips.filter(ticketS => {
                let t = ticketS.tickets.filter(tick => {
                    return tick.id === ticket.id;
                });

                return t.length > 0;
            });
            let check = result.length > 0;
            return check;
        },
        closeDialog() {
            this.close();
        },
        addTicket(ticket, checked) {
            if (checked) {
                this.ticketsSelected.push(ticket);
            } else {
                this.ticketsSelected.splice(this.ticketsSelected.indexOf(ticket.id), 1);
            }
        },
        close() {
            this.$parent.displayTicketStripSelect = false;
        },
        valid() {
            if (this.ticketsSelected.length === 0) {
                this.$swal({
                    title: "",
                    text: this.$t("configurator.messageAlert5"),
                    type: "warning",
                    // showCancelButton: true,
                    confirmButtonColor: "#41b4e8",
                    confirmButtonText: "OK"
                });
            } else {
                this.$parent.callbackTicketStrip(this.ticketsSelected);
                this.close();
            }
            // this.$parent.displayProductSelect = false
        }
    }
};
</script>

<style scoped lang="scss">
#modal {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 30;
    margin: auto;

    .close-dialog {
        position: absolute;
        background-image: url("../../assets/croix.png");
        background-size: 16px;
        right: 10px;
        height: 16px;
        width: 16px;
    }

    .ticket-select {
        background: #fff;
        padding: 30px; //   position: absolute;
        z-index: 200;
        width: 500px;
        /*height: 100%;*/
        /*max-height: 400px;*/
        overflow-y: auto;
        //   top: 0px;
        //   left: 0px;
        //   padding: 5px;
        border-radius: 3px;
        margin: 200px auto;

        .content-ticket {
            white-space: nowrap;
        }
    }

    .buttonbar {
        padding-top: 20px;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// TicketStripSelect.vue?3a25e87c